const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
const OPEN_CLOSE_ADVANCED_FILTER = 'OPEN_CLOSE_ADVANCED_FILTER';
const CLOSE_IF_OPEN_ADVANCED_FILTER = 'CLOSE_IF_OPEN_ADVANCED_FILTER';
const SET_ADVANCED_FILTER_OPEN_VALUE = 'SET_ADVANCED_FILTER_OPEN_VALUE';

export function setFilterParams(data) {
  return { type: SET_FILTER_PARAMS, payload: data };
}

export function openCloseAdvancedFilter() {
  return { type: OPEN_CLOSE_ADVANCED_FILTER };
}

export function closeIfOpenAdvancedFilter() {
  return { type: CLOSE_IF_OPEN_ADVANCED_FILTER };
}

export function setAdvancedFilterOpenInitialValue(isAdvancedFilterOpen) {
  return { type: SET_ADVANCED_FILTER_OPEN_VALUE, payload: isAdvancedFilterOpen };
}

const initialState = {
  filterParams: {
  },
  isAdvancedFilterOpen: false,
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_PARAMS: {
      return { ...state, filterParams: action.payload };
    }
    case OPEN_CLOSE_ADVANCED_FILTER: {
      return { ...state, isAdvancedFilterOpen: !state.isAdvancedFilterOpen };
    }
    case CLOSE_IF_OPEN_ADVANCED_FILTER: {
      return { ...state, isAdvancedFilterOpen: state.isAdvancedFilterOpen ? !state.isAdvancedFilterOpen : state.isAdvancedFilterOpen };
    }
    case SET_ADVANCED_FILTER_OPEN_VALUE: {
      return { ...state, isAdvancedFilterOpen: action.payload };
    }
    default:
  }
  return state;
};

export default filterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filterReducer.js